// src/components/LoadingSkeleton.js
import React from 'react';

export const CardSkeleton = () => (
    <div className="bg-gray-100 border border-gray-200 rounded-lg shadow p-4 animate-pulse">
        <div className="h-4 bg-gray-300 rounded w-3/4 mb-2"></div>
        <div className="h-8 bg-gray-300 rounded w-1/2 mb-1"></div>
        <div className="h-3 bg-gray-300 rounded w-1/3"></div>
    </div>
);

export const TableSkeleton = ({ rows = 5 }) => (
    <div className="bg-white rounded-lg shadow p-4 md:p-6 animate-pulse">
        <div className="h-6 bg-gray-300 rounded w-1/3 mb-4"></div>
        <div className="space-y-3">
            {[...Array(rows)].map((_, i) => (
                <div key={i} className="flex space-x-4">
                    <div className="h-4 bg-gray-200 rounded flex-1"></div>
                    <div className="h-4 bg-gray-200 rounded w-20"></div>
                </div>
            ))}
        </div>
    </div>
);

export const ChartSkeleton = ({ height = 250 }) => (
    <div className="bg-white rounded-lg shadow p-4 md:p-6 animate-pulse">
        <div className="h-6 bg-gray-300 rounded w-1/3 mb-4"></div>
        <div className="flex items-end space-x-2" style={{ height: `${height}px` }}>
            {[...Array(10)].map((_, i) => (
                <div
                    key={i}
                    className="bg-gray-200 rounded-t flex-1"
                    style={{ height: `${Math.random() * 70 + 30}%` }}
                ></div>
            ))}
        </div>
    </div>
);

export const PriorityCardsSkeleton = () => (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
    </div>
);

export const DashboardSkeleton = () => (
    <>
        <div className="flex justify-between items-center mb-6">
            <div className="h-7 bg-gray-300 rounded w-32 animate-pulse"></div>
            <div className="h-9 bg-gray-300 rounded w-40 animate-pulse"></div>
        </div>
        
        <PriorityCardsSkeleton />
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 mb-6 md:mb-8 mt-6">
            <TableSkeleton rows={3} />
            <TableSkeleton rows={6} />
        </div>
        
        <ChartSkeleton />
        
        <div className="mt-6 md:mt-8">
            <ChartSkeleton />
        </div>
    </>
);

